import React from "react";
import { Box } from "@chakra-ui/react";
import Layout from "../../components/dashboard/Layout";
import StudentPaymentsTable from "../../containers/admin/student-payments/table";

const StudentPaymentsPage = () => {
  return (
    <Layout>
      <Box w="100%" p={4}>
        <StudentPaymentsTable />
      </Box>
    </Layout>
  );
};

export default StudentPaymentsPage; 